export const splitMarkup = (markup: string): [string, string[]] => {
  const scriptRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
  const scripts = markup?.match(scriptRegex) || [];

  const html = markup?.replace(scriptRegex, '');

  return [html, scripts];
};
